import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';


const SubsequentInstalmentPeriodInput: InputWithSource = ({ input }) => (
    <GenericSelect label={input.name} input={input} />
);

SubsequentInstalmentPeriodInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(SubsequentInstalmentPeriodInput);
